import React from 'react';
import { Breadcrumb } from 'office-ui-fabric-react/lib/Breadcrumb'


import Activities from '../../activities/containers/Activities'
//import ActivitiesModule from '../../modules/activities/containers/AsyncApp'
import Competencies from '../../modules/competencies/containers/AsyncApp'



export default ({breadcrumbs,assessment })  => 
  <div>
    <Breadcrumb items={ breadcrumbs } ariaLabel={ 'Website breadcrumb' } />
    { assessment.activities
      ? 
      <div>
        <Activities items={assessment.activities} />
        {/*assessment && assessment.id ? <ActivitiesModule /> : '' */}
        {assessment && assessment.id ? <Competencies /> : '' }
      </div>
      : '' }   
    </div>
      
        




// WEBPACK FOOTER //
// ./src/assessments/components/Assessment.js